import { FIND_MY_INVOICES } from "../../graphql/invoices";
import { buildInvoice, buildUser, buildWorkerInfo } from "../factories";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { MockedProvider } from "@apollo/client/testing";
import React, { useMemo } from "react";
import ClientInvoicesScreen from "../../screens/client/InvoiceList";
import { ProfileType } from "../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";

const StoryComponent = () => {
    const mocks = [
        {
            request: {
                query: FIND_MY_INVOICES,
            },
            newData: () => ({
                data: {
                    findMyInvoices: {
                        count: 2,
                        elements: [
                            buildInvoice(),
                            buildInvoice({
                                paidAt: null,
                            }),
                        ],
                        pageInfo: {
                            currentOffset: 0,
                            previousOffset: -1,
                            nextOffset: -1,
                            hasNextPage: false,
                            hasPreviousPage: false,
                            limit: 100,
                        },
                    },
                },
            }),
        },
    ];
    const user = useMemo(
        () =>
            buildUser({
                workerInfo: buildWorkerInfo(),
            }),
        [],
    );
    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={ProfileType.Worker}>
                <MockedProvider mocks={mocks}>
                    <ClientInvoicesScreen />
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/InvoiceList",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
